/**
 * 认证工具函数
 * 统一处理登录、退出登录、Token 管理
 */
import AppConfig from '@/config';

/**
 * 退出登�?
 * 清理所有认证信息并跳转到登录页
 */
export async function logout() {
  // ����������֤��Ϣ�����ݶ��ֱ��淽ʽ��ȫ������
  const keys = [
    'token',
    'auth_token',
    'authToken',
    'access_token',
    'Authorization',
    'user_identity',
    'identity',
    'identityId',
    'userId',
    'user_id',
    'userInfo',
    'user_features',
    'user_role',
    'stored_wholesaler_id',
    'stored_customer_id',
    'wholesaler_id',
    'customer_id',
    'driver_id',
    'url_wholesaler_id',
    'login_redirect',
    'tempUsername',
    'tempPassword',
    'tempToken',
    'tempUserId',
    'needsRoleSelect',
    'needsIdentitySelect',
    'wholesalerOptions',
    'userFeatures',
    'customerId'
  ];

  keys.forEach(k => {
    localStorage.removeItem(k);
    sessionStorage.removeItem(k);
  });

  // ǿ��ˢ��ҳ�棬ȷ��״̬��ȫ���
  window.location.href = '/login';
}

// �ɴ������滻������Ϊע�ͣ�
/*

  // 清理所有认证信�?兼容多种保存方式，全部清�?
  const keys = [
    AppConfig.tokenKey,   // 你项目里配置�?token key，如果没有可以忽�?
    'token',              // 这个页面 mounted 里用�?
    'authToken',
    'auth_token',       // �?路由守卫真正用的 key
    'access_token',
    'Authorization',
    'user_identity',
    'userId',
    'userInfo'
  ];

  keys.forEach(k => {
    localStorage.removeItem(k);
    sessionStorage.removeItem(k);
  });

  // 跳转到登录页
  try {
    await router.replace('/login'); // �?replace 更合�?
  } catch (err) {
    // 如果是“被重定向”或“重复导航”这�?NavigationFailure，就直接忽略
    // if (isNavigationFailure(err, NavigationFailureType.redirected)) {
    //   return;
    // }
    // if (isNavigationFailure(err, NavigationFailureType.duplicated)) {
    //   return;
    // }
    // 其他错误打印出来，方便排�?
    console.error('跳转登录页失�?', err);
  }
}

/**
 * 检查是否已登录
 * @returns {boolean}
 */
export function isLoggedIn() {
  return !!localStorage.getItem(AppConfig.tokenKey);
}

/**
 * 获取当前 Token
 * @returns {string|null}
 */
export function getToken() {
  return localStorage.getItem(AppConfig.tokenKey);
}

/**
 * 保存 Token
 * @param {string} token
 */
export function setToken(token) {
  localStorage.setItem(AppConfig.tokenKey, token);
}
